define("settings/controllers/groups/trade", ["exports", "ember-concurrency/-private/async-arrow-runtime", "@ember/array", "@ember/controller", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "lodash", "shared/utils/object-promise-proxy"], function (_exports, _asyncArrowRuntime, _array, _controller, _service, _utils, _tracking, _emberConcurrency, _lodash, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _disableLinkinbioForSocialProfilesMovedBetweenGroups, _doesProfileHaveLinkinbioFeed, _getFormattedGroups, _getFormattedIdentities, _getFormattedSocialProfiles, _getLinkinbioDescription;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"@ember/array",0,"@ember/controller",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash",0,"shared/utils/object-promise-proxy"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let TradeController = (_class = (_disableLinkinbioForSocialProfilesMovedBetweenGroups = /*#__PURE__*/new WeakSet(), _doesProfileHaveLinkinbioFeed = /*#__PURE__*/new WeakSet(), _getFormattedGroups = /*#__PURE__*/new WeakSet(), _getFormattedIdentities = /*#__PURE__*/new WeakSet(), _getFormattedSocialProfiles = /*#__PURE__*/new WeakSet(), _getLinkinbioDescription = /*#__PURE__*/new WeakSet(), class TradeController extends _controller.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _getLinkinbioDescription);

      _classPrivateMethodInitSpec(this, _getFormattedSocialProfiles);

      _classPrivateMethodInitSpec(this, _getFormattedIdentities);

      _classPrivateMethodInitSpec(this, _getFormattedGroups);

      _classPrivateMethodInitSpec(this, _doesProfileHaveLinkinbioFeed);

      _classPrivateMethodInitSpec(this, _disableLinkinbioForSocialProfilesMovedBetweenGroups);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);

      _initializerDefineProperty(this, "errors", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "intl", _descriptor6, this);

      _initializerDefineProperty(this, "router", _descriptor7, this);

      _initializerDefineProperty(this, "store", _descriptor8, this);

      _initializerDefineProperty(this, "movedSocialProfiles", _descriptor9, this);

      _initializerDefineProperty(this, "movedSocialIdentities", _descriptor10, this);

      _initializerDefineProperty(this, "profilesMovedBetweenGroups", _descriptor11, this);

      _defineProperty(this, "confirmMove", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (incomingProfiles, didMoveProfilesBetweenGroups) {
          let outgoingProfile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
          const profilesWithLinkinbioFeed = [];
          const creatorProfiles = [];

          const doesOutgoingProfileHaveLinkinbioFeed = _classPrivateMethodGet(this, _doesProfileHaveLinkinbioFeed, _doesProfileHaveLinkinbioFeed2).call(this, outgoingProfile);

          incomingProfiles.forEach(profile => {
            if (_classPrivateMethodGet(this, _doesProfileHaveLinkinbioFeed, _doesProfileHaveLinkinbioFeed2).call(this, profile)) {
              profilesWithLinkinbioFeed.push(profile);
            }

            if (profile.get('socialIdentity.influencerId')) {
              creatorProfiles.push(profile);
            }
          });
          const shouldConfirmMove = didMoveProfilesBetweenGroups || profilesWithLinkinbioFeed.length || creatorProfiles.length || doesOutgoingProfileHaveLinkinbioFeed;
          return shouldConfirmMove ? yield this.dialogManager.confirmation(this.intl.t('account.groups.group.social_profiles.move.confirm_title', {
            count: incomingProfiles.length
          }), {
            description: yield this.getConfirmationDescription.perform(profilesWithLinkinbioFeed, creatorProfiles, doesOutgoingProfileHaveLinkinbioFeed ? outgoingProfile : undefined),
            confirmButton: this.intl.t('account.groups.group.social_profiles.move.confirm_button')
          }) : true;
        }
      }), {
        drop: true
      }, "confirmMove", null));

      _defineProperty(this, "getConfirmationDescription", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (profilesWithLinkinbioFeed, creatorProfiles, outgoingProfileWithLinkinbioFeed) {
          const confirmMoveDescription = this.intl.t('account.groups.group.social_profiles.move.confirm');

          if ((0, _utils.isEmpty)(profilesWithLinkinbioFeed) && (0, _utils.isEmpty)(creatorProfiles) && (0, _utils.isEmpty)(outgoingProfileWithLinkinbioFeed)) {
            return confirmMoveDescription;
          }

          const linkinbioDescription = _classPrivateMethodGet(this, _getLinkinbioDescription, _getLinkinbioDescription2).call(this, profilesWithLinkinbioFeed, outgoingProfileWithLinkinbioFeed);

          const creatorDescription = yield this.getCreatorDescription.perform(linkinbioDescription, creatorProfiles);
          return creatorDescription.concat('<br><br>', confirmMoveDescription);
        }
      }), null, "getConfirmationDescription", null));

      _defineProperty(this, "getCreatorDescription", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          let linkinbioDescription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          let creatorProfiles = arguments.length > 1 ? arguments[1] : undefined;

          try {
            if (this.canAccessOCE && (0, _utils.isPresent)(creatorProfiles)) {
              let creatorDescription = this.intl.t('account.groups.group.social_profiles.move.confirm_creator_applicant');
              let campaigns = [];
              const hasRequiredProfile = (0, _utils.isPresent)(creatorProfiles.filter(socialProfile => socialProfile.isInstagram || socialProfile.isFacebook));
              const resolvedInfluencers = yield Promise.all(creatorProfiles.map(socialProfile => (0, _objectPromiseProxy.default)(socialProfile.get('socialIdentity.influencer'))));
              const influencers = (0, _lodash.uniqBy)(resolvedInfluencers, 'id');

              for (const influencer of influencers) {
                const active = yield influencer.manageCampaigns({
                  status: 'active'
                });
                const applied = yield influencer.manageCampaigns({
                  status: 'applied'
                });
                campaigns = [...campaigns, ...active.campaign, ...applied.campaign];
              }

              campaigns = campaigns.flat();

              if (hasRequiredProfile) {
                creatorDescription = creatorDescription.concat('<br><br>', this.intl.t('account.groups.group.social_profiles.move.confirm_creator_profile'));
              }

              if ((0, _utils.isPresent)(campaigns)) {
                creatorDescription = creatorDescription.concat('<br><br>', this.intl.t('account.groups.group.social_profiles.move.confirm_creator_required_applicant'));
              }

              return (0, _utils.isPresent)(linkinbioDescription) ? linkinbioDescription.concat('<br/><br/>', creatorDescription) : creatorDescription;
            }

            return linkinbioDescription;
          } catch (error) {
            this.errors.log(error);
          }
        }
      }), null, "getCreatorDescription", null));

      _defineProperty(this, "saveChanges", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          //created group is necessary for collectionAction - Ian K
          const tempGroup = this.store.createRecord('group');
          const groups = {
            groups: _classPrivateMethodGet(this, _getFormattedGroups, _getFormattedGroups2).call(this)
          };
          const response = yield tempGroup.rearrange(groups);
          this.store.pushPayload(response);

          _classPrivateMethodGet(this, _disableLinkinbioForSocialProfilesMovedBetweenGroups, _disableLinkinbioForSocialProfilesMovedBetweenGroups2).call(this);

          this.trackChangesInSegment();
          this.alerts.success(this.intl.t('alerts.account.groups.group.social_profiles.move.update_success'));
          this.router.transitionTo('account.groups');
        }
      }), null, "saveChanges", null));

      _defineProperty(this, "trackGroupTrade", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (_ref) {
          let {
            identity
          } = _ref;
          const didMoveProfilesBetweenGroups = identity.socialProfiles.length > 0;
          const didConfirm = this.confirmMove.perform(identity.socialProfiles, didMoveProfilesBetweenGroups);

          if (didConfirm) {
            this.movedSocialIdentities.addObject(identity);
            identity.socialProfiles.forEach(profile => {
              this.movedSocialProfiles.addObject(profile);
              this.profilesMovedBetweenGroups.addObject(profile);
            });
          }

          return didConfirm;
        }
      }), null, "trackGroupTrade", null));

      _defineProperty(this, "trackProfileTrade", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (_ref2, didMoveProfileBetweenGroups, _ref3) {
          let {
            profile: incomingProfile
          } = _ref2;
          let {
            profile: outgoingProfile
          } = _ref3;

          if (incomingProfile) {
            const didConfirm = yield this.confirmMove.perform([incomingProfile], didMoveProfileBetweenGroups, outgoingProfile);

            if (didConfirm) {
              this.movedSocialProfiles.addObject(incomingProfile);

              if (didMoveProfileBetweenGroups) {
                this.profilesMovedBetweenGroups.addObject(incomingProfile);
              }
            }

            return didConfirm;
          }
        }
      }), null, "trackProfileTrade", null));
    }

    get lastGroup() {
      return this.auth.lastGroup;
    }

    get movedSocialProfilesCount() {
      return this.movedSocialProfiles.length;
    }

    get movedSocialIdentitiesCount() {
      return this.movedSocialIdentities.length;
    }

    get movedSocialProfileTypes() {
      return this.movedSocialProfiles.map(profile => profile.profileType);
    }

    get movedSocialProfileNicknames() {
      return this.movedSocialProfiles.map(profile => profile.nickname);
    }

    get movedSocialProfileIds() {
      return this.movedSocialProfiles.map(profile => profile.id);
    }

    get canAccessOCE() {
      return this.auth.currentAccount.rolloutOcePhase1;
    }

    trackChangesInSegment() {
      this.segment.track('moved-social-profile', {
        moved_social_set: this.movedSocialIdentitiesCount,
        moved_social_profile: this.movedSocialProfilesCount,
        profile_types: this.movedSocialProfileTypes,
        profile_nicknames: this.movedSocialProfileNicknames,
        profile_ids: this.movedSocialProfileIds
      }, {
        user: 'currentUserModel.id'
      });
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "movedSocialProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "movedSocialIdentities", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "profilesMovedBetweenGroups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  })), _class);
  _exports.default = TradeController;

  function _disableLinkinbioForSocialProfilesMovedBetweenGroups2() {
    this.profilesMovedBetweenGroups.forEach(profile => {
      profile.setProperties({
        linkinbioEnabled: false
      });
    });
  }

  function _doesProfileHaveLinkinbioFeed2(profile) {
    return Boolean(profile?.get('linkinbioPage'));
  }

  function _getFormattedGroups2() {
    return this.groups.map(group => {
      return {
        id: group.id,
        social_identities: _classPrivateMethodGet(this, _getFormattedIdentities, _getFormattedIdentities2).call(this, group)
      };
    });
  }

  function _getFormattedIdentities2(group) {
    return (0, _utils.isEmpty)(group.temporaryIdentities) && group.traded !== true ? group.socialIdentities.filter(identity => identity.id).map(identity => {
      return {
        id: identity.id,
        social_profiles: _classPrivateMethodGet(this, _getFormattedSocialProfiles, _getFormattedSocialProfiles2).call(this, identity)
      };
    }) : group.temporaryIdentities.filter(tempIdentity => tempIdentity.identity).map(tempIdentity => {
      return {
        id: tempIdentity.identity.id,
        social_profiles: _classPrivateMethodGet(this, _getFormattedSocialProfiles, _getFormattedSocialProfiles2).call(this, tempIdentity.identity)
      };
    });
  }

  function _getFormattedSocialProfiles2(identity) {
    return (0, _utils.isEmpty)(identity.temporaryProfiles) ? identity.socialProfiles.filter(profile => profile).map(profile => {
      return {
        id: profile.id
      };
    }) : identity.temporaryProfiles.filter(tempProfile => tempProfile.profile).map(tempProfile => {
      return {
        id: tempProfile.profile.id
      };
    });
  }

  function _getLinkinbioDescription2(profilesWithLinkinbioFeed, outgoingProfileWithLinkinbio) {
    const profilesWithFeed = profilesWithLinkinbioFeed;

    if (outgoingProfileWithLinkinbio) {
      profilesWithFeed.push(outgoingProfileWithLinkinbio);
    } //Note: structure is {'urlName': [{platform: 'platform', name: 'name'}]}


    const pagesWithFeed = {};
    profilesWithFeed.forEach(profile => {
      const url = profile.get('linkinbioPage.urlName');
      const config = {
        platform: profile.localizedAccountType,
        name: profile.displayNickname
      };

      if (Object.prototype.hasOwnProperty.call(pagesWithFeed, url)) {
        pagesWithFeed[url].push(config);
      } else {
        pagesWithFeed[url] = [config];
      }
    });
    let message = '';
    Object.keys(pagesWithFeed).forEach((pageName, index) => {
      let pageMessage = '';
      const profiles = pagesWithFeed[pageName];
      profiles.forEach(profile => {
        if (pageMessage) {
          pageMessage += ` ${this.intl.t('account.groups.group.social_profiles.move.confirm_linkinbio_enabled_additional', {
            platform: profile.platform,
            name: profile.name
          })}`;
        } else {
          if (index != 0) {
            pageMessage += `<br><br>`;
          }

          pageMessage += `${this.intl.t('account.groups.group.social_profiles.move.confirm_linkinbio_enabled', {
            url: pageName,
            platform: profile.platform,
            name: profile.name
          })}`;
        }
      });
      message += `${pageMessage}.`;
    });
    return message;
  }
});